/** Saha (field) JWT + localStorage için tutarlı personel rolü */

export type FieldPersonnelRole = 'admin' | 'expert' | 'doctor' | 'coordinator' | 'auditor' | 'arsiv';

/**
 * Mobil login cevabı `personnel.type`, bazı sürümlerde `personnel.userType`; büyük/küçük harf değişebilir.
 */
export function normalizeFieldPersonnelRole(
  raw?: string | null
): FieldPersonnelRole {
  const t = String(raw ?? '').trim().toLowerCase();
  if (t === 'admin' || t === 'adm' || t === 'administrator') {
    return 'admin';
  }
  if (t === 'coordinator' || t === 'koordinator' || t.includes('koordinat')) {
    return 'coordinator';
  }
  if (t === 'auditor' || t === 'denetci' || t.includes('denet')) {
    return 'auditor';
  }
  if (t === 'arsiv' || t === 'archive' || t.includes('arsiv') || t.includes('arşiv')) {
    return 'arsiv';
  }
  if (
    t === 'doctor' ||
    t.includes('doctor') ||
    (t.includes('hekim') && !t.includes('uzman'))
  ) {
    return 'doctor';
  }
  return 'expert';
}

export function fieldPersonnelUsesDoctorVisits(role: FieldPersonnelRole): boolean {
  return role === 'doctor';
}
